module.exports = __webpack_public_path__ + "media/images/patterns/oranges-c3437cd6079a20c642e8401d0d2cc541.svg";